module.exports = __webpack_public_path__ + "static/img/alipay.63cec34.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/subscribe/alipay.jpg
// module id = pFPy
// module chunks = 1